import { PromoCodeDelete } from '../../domain/PromoCodesSlice/PromoCodeDelete';
import { PromoCodeGet } from '../../domain/PromoCodesSlice/PromoCodeGet';
import { PromoCodeInsert } from '../../domain/PromoCodesSlice/PromoCodeInsert';
import { PromoCodeUpdateDates } from '../../domain/PromoCodesSlice/PromoCodeUpdateDates';
import { PromoCodeUpdateStatus } from '../../domain/PromoCodesSlice/PromoCodeUpdateStatus';
import { PromoCodeValidate } from '../../domain/PromoCodesSlice/PromoCodeValidate';
import ApiWrapperAuthenticated from '../Common/ApiWrapperAuthenticated';

export class PromoCodeRepository 
    extends ApiWrapperAuthenticated<void, PromoCodeInsert, void, PromoCodeDelete> {
    constructor() {
        super('promos/');
    }

    async fetchAllVisible(): Promise<PromoCodeGet[] | null> {
        return await this.getListAllCustom({ url: 'visible' });
    }

    async validatePromo(promo: PromoCodeValidate): Promise<PromoCodeGet | null> {
        return await this.postCustom({ url: 'validate', data: promo });
    }

    async fetchAllUpcoming(): Promise<PromoCodeGet[] | null> {
        return await this.getListAllAuthenticatedCustom({ url: 'upcoming' });
    }

    async fetchUpcomingVisibleExists(): Promise<boolean | null> {
        return await this.getOneAuthenticatedCustom({ url: 'upcoming-visible-exists' });
    }

    async updatePromoDates(promo: PromoCodeUpdateDates): Promise<void> {
        await this.putAuthenticatedCustom({ url: 'dates', data: promo });
    }

    async updatePromoStatus(promo: PromoCodeUpdateStatus): Promise<void> {
        await this.putAuthenticatedCustom({ url: 'active', data: promo });
    }
}
